import React from "react";
import { Link } from "@quintype/components";
import "./renewal-banner.m.css";

export const RenewalBanner = () => {
  return (
    <div styleName="wrapper" className="full-width">
      <div styleName="text-wrapper">
        <p>
          {" "}
          Your subscription has <u>expired</u>. Power our ad-free, independent
          journalism.
        </p>
      </div>

      <div styleName="cta-wrapper">
        <Link href="/subscription?ref=renewal-banner">
          <button styleName="sub-btn">Subscribe now</button>
        </Link>
      </div>
    </div>
  );
};
